import { styled } from '@mui/material/styles';
import MuiAccordion        from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';

export const Accordion = styled(MuiAccordion)(({ theme }) => ({
	// No specific styling needed
}));

export const AccordionSummary = styled(MuiAccordionSummary)(({ theme }) => ({
	'&.MuiAccordionSummary-root': {
		padding: '0px'
	}
}));

export const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
	'&.MuiAccordionDetails-root': {
		padding: '0px'
	}
}));
